import { hubAxios } from "@helpers/lib/axios";
import { HUB_ENDPOINTS } from "@memorang/constants/urls";
import type { UserInfo } from "@memorang/types";
import type { AxiosResponse } from "axios";

export type UpdateUserFields = {
	firstName?: string;
	lastName?: string;
	username?: string;
	metadata?: Record<string, unknown>;
};

export const fetchUser = async () => {
	const { data } = await hubAxios.get<UserInfo>(HUB_ENDPOINTS.USERS_ME);
	return data;
};

export const updateUser = async (body: UpdateUserFields) => {
	const { data } = await hubAxios.patch<
		UpdateUserFields,
		AxiosResponse<UserInfo>
	>(HUB_ENDPOINTS.USERS_ME, body);

	return data;
};
